export { PoweredByFooter } from './PoweredByFooter';
export type { PoweredByFooterProps } from './PoweredByFooter';
